/* eslint-disable no-unused-vars */
import {
  Grid,
  VirtualizedCell,
  defaultVirtualizedCellRender,
  extractAndFormatData,
  virtualizedGridRenderer,
} from '@integec/grid-tools'
import { Button, Divider, Modal, Spin, Tabs, Switch, message } from 'antd'
import { getApiTargetInfo } from 'core'
import React, { useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import R from 'ramda'
import {
  SolarTmpImpactSummaryHeaders,
  SolarTmpInvEventImpactHeaders,
  SolarTmpInvHoursImpactHeaders,
  SolarTmpNercEventImpactHeaders,
  SolarTmpNercHoursImpactHeaders,
} from './Headers'
import { rowHeaderRender } from 'core/utils'
import {
  JcTmpErrorTable,
  isErrorContains,
} from 'core/component/JcTmpErrorDialog'
import { Filler, FullHeightSizer } from 'core/screen-util'
import styled from 'styled-components'

const ImpactAnalysis = ({
  targetInfo,
  data = {},
  onClose,
  setSpinning,
  spinning,
  request = {},
  setError,
  setImpactAnalysisData,
  callImpactAnalysisExecuteApi,
  impactAnalysisApi,
  retrieveData,
  setTmpError,
  width = 900,
  height = 550,
  createorprocess,
}) => {
  const {
    impactSummary = [],
    inverterEventImpact = [],
    inverterHourImpact = [],
    nercEventImpact = [],
    nercHourImpact = [],
    errors = [],
  } = data
  const [actionKey, setActionKey] = useState('summary')
  const [isShowAllData, setIsShowAllData] = useState(false)

  useEffect(_ => setActionKey(errors.length > 0 ? 'error' : 'summary'), [
    errors,
  ])

  const impactSummaryEff = useMemo(
    _ => {
      const eff = impactSummary.filter(f => f.tabId === '0' || f.tabId === 0)

      const hidesummaryAll0 = e => {
        if (
          (e.invEventImpact === '0' || e.invEventImpact === 0) &&
          (e.nercEventImpact === '0' || e.nercEventImpact === 0) &&
          (e.invHoursImpact === '0' || e.invHoursImpact === 0) &&
          (e.nercEventHourImpact === '0' || e.nercEventHourImpact === 0)
        )
          return false
        return true
      }

      const finalEff = eff.filter(e => isShowAllData || hidesummaryAll0(e))
      return finalEff
    },
    [impactSummary, isShowAllData]
  )

  const executeAnalysis = _ => {
    setSpinning(true)
    callImpactAnalysisExecuteApi(createorprocess)
    // impactAnalysisExecuteApi().fork(setError, data => {
    //   setSpinning(false)
    //   message.info('Process completed successfully.')

    //   // setImpactAnalysisData(data)
    //   const { errors } = data
    //   setTmpError(errors)
    //   if(!isErrorContains(errors)){
    //   retrieveData()
    //   onClose()}
    // })
  }
  // const analysisAgain = _ => {
  //   setSpinning(true)
  //   impactAnalysisApi().fork(setError, data => {
  //     setSpinning(false)
  //     setImpactAnalysisData(data)
  //   })
  // }

  const getImpactString = id => {
    return impactSummary.find(d => d.tabId === id) || { description: '' }
  }

  const getBackgroundColor = cellData =>
    cellData === 'Delete'
      ? '#f4dfe0'
      : cellData === 'Add'
      ? '#0080003b'
      : cellData === 'Modify'
      ? 'yellow'
      : undefined

  const operationCellRender = props => {
    const { gridToolProps, reactVirtualizedProps } = props

    const { getCellProps, headers, data } = gridToolProps

    const { columnIndex, rowIndex } = reactVirtualizedProps

    if (headers[columnIndex].ident === 'operation') {
      let modifierProps = getCellProps({
        rowIndex,
        columnIndex,
        header: headers.find(h => h.ident === 'operation'),
        data,
        style: reactVirtualizedProps.style,
      })
      const cellData = extractAndFormatData({
        rowData: data[rowIndex],
        header: headers[columnIndex],
      })
      // const modifiercellData = extractAndFormatData({
      //   rowData: data[rowIndex],
      //   header: headers.find(h=>h.ident==='modifier'),
      // })

      // const isDeleted = cellData === 'Deleted' // Unchanged=none ,  Added=green  Modified =yellow

      // const color = isDeleted ? 'black' : 'black'

      // eslint-disable-next-line no-unused-vars
      let { style, isSelected, ...rest } = modifierProps

      style = {
        ...style,
        backgroundColor: getBackgroundColor(cellData) || style.backgroundColor,
        color: isSelected ? 'black' : style.color,
      }
      modifierProps = { ...rest, style, isSelected }

      return (
        <VirtualizedCell {...R.omit(['data'], modifierProps)}>
          {cellData}
        </VirtualizedCell>
      )
    }
    return defaultVirtualizedCellRender(props)
  }
  const filterUnchnagedData = data =>
    data.filter(d => isShowAllData || d.operation !== 'No Change')

  const finalWidth = width - 30
  return (
    <Spin spinning={spinning}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 5 }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'auto 250px',
            gap: 5,
            justifyContent: 'space-between',
          }}
        >
          {/* <Button onClick={onClose} loading={spinning}>
            Abort
          </Button>
          <Button onClick={executeAnalysis} loading={spinning} type="primary">
            Continue
          </Button>
          <Button onClick={analysisAgain} loading={spinning} type="primary">
            Re-Analysis
          </Button> */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns:
                '70px 10px 60px 50px 80px 50px 80px 50px 10px',
              justifyContent: 'center',
              gap: '5px',
              borderLeft: '0px solid gray',
              borderRight: '0px solid gray',
            }}
          >
            <div>Legend :</div>
            <Divider
              type="vertical"
              style={{ height: '100%', backgroundColor: '#8080807a' }}
            />
            <div
              style={{
                textAlign: 'end',
                alignContent: 'center',
                display: 'grid',
              }}
            >
              Add
            </div>
            <div
              style={{
                backgroundColor: getBackgroundColor('Add'),
                border: '0px solid black',
                textAlign: 'center',
                fontWeight: '700',
                color: '#c5e0b4',
                height: '70%',
                alignSelf: 'center',
              }}
            />
            <div
              style={{
                textAlign: 'end',
                alignContent: 'center',
                display: 'grid',
              }}
            >
              Modify
            </div>
            <div
              style={{
                backgroundColor: getBackgroundColor('Modify'),
                border: '0px solid black',
                textAlign: 'center',
                fontWeight: '700',
                color: '#c5e0b4',
                height: '70%',
                alignSelf: 'center',
              }}
            />
            <div
              style={{
                textAlign: 'end',
                alignContent: 'center',
                display: 'grid',
              }}
            >
              Delete
            </div>
            <div
              style={{
                backgroundColor: getBackgroundColor('Delete'),
                border: '0px solid black',
                textAlign: 'center',
                fontWeight: '700',
                color: '#f4dfe0',
                height: '70%',
                alignSelf: 'center',
              }}
            />
            <Divider
              type="vertical"
              style={{ height: '100%', backgroundColor: '#8080807a' }}
            />
          </div>
          <div>
            Show Unchanged Data :{' '}
            <Switch value={isShowAllData} onChange={setIsShowAllData} />
          </div>
        </div>
        <Divider style={{ margin: '1px' }} />
        <div>
          <Tabs activeKey={actionKey} onChange={setActionKey} type="card">
            <Tabs.TabPane tab="Impact Summary" key="summary">
              <div style={{ width, height }}>
                {/* <div>Impact : {getImpactString('TAB1').description}</div> */}
                <Grid
                  //     sortEnabled
                  data={impactSummaryEff}
                  headers={SolarTmpImpactSummaryHeaders}
                  altBy={u => u.nn}
                  altBgColor="#ebebeb"
                  // onEditInfoChange={info => editRow(info)}
                  // editInfo={editInfo}
                  render={virtualizedGridRenderer({
                    autoFixColByKey: false,
                    rowHeaderRender,
                    height: height - 20,
                    width: finalWidth,
                    headerRowHeight: 60,
                  })}
                  //   fuzzyFilter={fuzzyFilter}
                  isEditable={false}
                  selectionMode="single"
                  selectionType="row"
                  //   initialSortOptions={SolarTmpImpactSummaryHeaders}
                />
              </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab="NERC Event Impact" key="nercEvent">
              <div style={{ width, height }}>
                <div style={{ marginBottom: '5px' }}>
                  Impact : <b>{getImpactString('2').description}</b>
                </div>
                <Grid
                  //   sortEnabled
                  data={filterUnchnagedData(nercEventImpact)}
                  headers={SolarTmpNercEventImpactHeaders}
                  altBy={u => u.eventId}
                  altBgColor="#ebebeb"
                  // onEditInfoChange={info => editRow(info)}
                  // editInfo={editInfo}
                  render={virtualizedGridRenderer({
                    autoFixColByKey: false,
                    rowHeaderRender,
                    height: height - 20,
                    width: finalWidth,
                    cellRender: operationCellRender,
                    headerRowHeight: 30,
                  })}
                  //   fuzzyFilter={fuzzyFilter}
                  isEditable={false}
                  selectionMode="single"
                  selectionType="row"
                  //  initialSortOptions={SolarTmpNercEventImpactHeaders}
                />
              </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Inv. Event Impact" key="invEvent">
              <div style={{ width, height, gap: 5 }}>
                <div style={{ marginBottom: '5px' }}>
                  Impact :<b> {getImpactString('1').description}</b>
                </div>
                <Grid
                  //   sortEnabled
                  data={filterUnchnagedData(inverterEventImpact)}
                  headers={SolarTmpInvEventImpactHeaders}
                  altBy={u => u.eventId}
                  altBgColor="#ebebeb"
                  // onEditInfoChange={info => editRow(info)}
                  // editInfo={editInfo}
                  render={virtualizedGridRenderer({
                    autoFixColByKey: false,
                    rowHeaderRender,
                    height: height - 20,
                    width: finalWidth,
                    cellRender: operationCellRender,
                    headerRowHeight: 30,
                  })}
                  //   fuzzyFilter={fuzzyFilter}
                  isEditable={false}
                  selectionMode="single"
                  selectionType="row"
                  // initialSortOptions={SolarTmpInvEventImpactHeaders}
                />
              </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab="NERC Hours Impact" key="nercHours">
              <div style={{ width, height }}>
                <div style={{ marginBottom: '5px' }}>
                  Impact : <b>{getImpactString('4').description}</b>
                </div>
                <Grid
                  //  sortEnabled
                  data={filterUnchnagedData(nercHourImpact)}
                  headers={SolarTmpNercHoursImpactHeaders}
                  altBy={u => u.month}
                  altBgColor="#ebebeb"
                  // onEditInfoChange={info => editRow(info)}
                  // editInfo={editInfo}
                  render={virtualizedGridRenderer({
                    autoFixColByKey: false,
                    rowHeaderRender,
                    height: height - 20,
                    width: finalWidth,
                    headerRowHeight: 30,
                    cellRender: operationCellRender,
                  })}
                  //   fuzzyFilter={fuzzyFilter}
                  isEditable={false}
                  selectionMode="single"
                  selectionType="row"
                  // initialSortOptions={SolarTmpNercHoursImpactHeaders}
                />
              </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Inv. Hours Impact" key="invHours">
              <div style={{ width, height }}>
                <div style={{ marginBottom: '5px' }}>
                  Impact :<b> {getImpactString('3').description}</b>
                </div>
                <Grid
                  // sortEnabled
                  data={filterUnchnagedData(inverterHourImpact)}
                  headers={SolarTmpInvHoursImpactHeaders}
                  altBy={u => u.month}
                  altBgColor="#ebebeb"
                  // onEditInfoChange={info => editRow(info)}
                  // editInfo={editInfo}
                  render={virtualizedGridRenderer({
                    autoFixColByKey: false,
                    rowHeaderRender,
                    height: height - 20,
                    width: finalWidth,
                    headerRowHeight: 30,
                    cellRender: operationCellRender,
                  })}
                  //   fuzzyFilter={fuzzyFilter}
                  isEditable={false}
                  selectionMode="single"
                  selectionType="row"
                  //  initialSortOptions={SolarTmpInvHoursImpactHeaders}
                />
              </div>
            </Tabs.TabPane>

            <Tabs.TabPane tab="Errors / Warning" key="error">
              <div style={{ minHeight: height }}>
                <JcTmpErrorTable
                  errors={errors}
                  scroll={{ y: height }}
                  style={{ minHight: height }}
                />
              </div>
            </Tabs.TabPane>
          </Tabs>
        </div>
        <Divider style={{ margin: '2px 0px' }} />
        <div
          style={{
            border: '0px solid #e8e8e8',
            // padding: 5,
            // marginTop: 5,
            display: 'grid',
            gridTemplateColumns: 'auto 150px 150px',
            gap: 50,
            marginRight: 100,
          }}
        >
          <Filler />
          <Button
            onClick={executeAnalysis}
            loading={spinning}
            type="primary"
            style={{}}
          >
            Continue
          </Button>
          <Button onClick={onClose} loading={spinning} type="danger">
            Abort
          </Button>
        </div>
      </div>
    </Spin>
  )
}

const ImpactAnalysisModal = ({
  targetInfo,
  data,
  onClose,
  visible,
  setSpinning,
  spinning,
  request = {},
  setError,
  setImpactAnalysisData,
  callImpactAnalysisExecuteApi,
  impactAnalysisApi,
  retrieveData,
  setTmpError,
  createorprocess,
}) => {
  return (
    // <div style={{ top: '0px' }}>
    //   <FullHeightSizer heightOffset={200} widthOffset={20}>
    //     {({ height, width }) => (
    <Modal
      loading={spinning}
      title={`Impact Analysis -  ${request.year}/${request.month}  -  ${request.plantName} `}
      // title="Impact Analysis"
      width={1100}
      height={750}
      visible={visible}
      onCancel={onClose}
      centered={false}
      bodyStyle={{ overflowY: 'auto', top: '5px' }}
      maskClosable={false}
      onOk={onClose}
      okText="OK"
      footer={null}
      style={{ top: '5px' }}
    >
      <ImpactAnalysis
        targetInfo={targetInfo}
        data={data}
        visible={visible}
        onClose={onClose}
        setSpinning={setSpinning}
        spinning={spinning}
        request={request}
        setError={setError}
        setImpactAnalysisData={setImpactAnalysisData}
        callImpactAnalysisExecuteApi={callImpactAnalysisExecuteApi}
        impactAnalysisApi={impactAnalysisApi}
        retrieveData={retrieveData}
        setTmpError={setTmpError}
        width={1100 - 30}
        height={750 - 50}
        createorprocess={createorprocess}
      />
    </Modal>
    //     )}
    //   </FullHeightSizer>
    // </div>
  )
}

export default ImpactAnalysisModal
